<template>
  <div>
    <v-main>
      <v-container fluid>
        <!-- <app-headline :title="title + ' ของ ' + this.$username" /> -->
        <v-row>
          <v-col>
            <v-card
              class="py-6"
              :class="$vuetify.breakpoint.smAndUp ? 'px-8' : 'px-5'"
            >
              <v-container class="py-0">
                <app-headline title="Preview" />
                <v-divider class="mt-2"></v-divider>

                <v-row>
                  <v-col lg="6" cols="12">
                    <v-text-field
                      v-model="number"
                      outlined
                      label="ที่ อว."
                      dense
                      hide-details
                      class="py-2"
                    ></v-text-field>
                    <v-select
                      v-if="docLang === 'Tha'"
                      v-model="addr"
                      :items="addrSelectData"
                      label="ที่อยู่"
                      item-text="name"
                      item-value="text"
                      outlined
                      dense
                      hide-details
                      class="py-2"
                    ></v-select>
                    <v-textarea
                      v-model="paragraph"
                      outlined
                      label="Paragraph 1"
                      dense
                      hide-details
                      class="py-2"
                    ></v-textarea>
                    <v-select
                      v-model="exec"
                      :items="execList"
                      label="ชื่อผู้ลงนาม"
                      :item-text="'employeeNamePosition' + docLang"
                      return-object
                      outlined
                      dense
                      hide-details
                      class="py-2"
                    ></v-select>
                    <div
                      v-if="exec[`positionExecName${docLang}`]"
                      class="px-2 py-1"
                    >
                      ตำแหน่ง :
                      <span class="grey--text"
                        >{{ exec[`positionExecName${docLang}`] }}
                        {{ exec[`organizationExecLevel1Name${docLang}`] }}</span
                      >
                    </div>
                    <v-text-field
                      v-model="replace"
                      outlined
                      label="ตำแหน่งปฎิบัติงานแทน "
                      placeholder="เช่น. ปฏิบัติการแทนอธิการบดีมหาวิทยาลัยเชียงใหม่"
                      dense
                      hide-details
                      class="py-2"
                    ></v-text-field>
                    <v-text-field
                      v-if="docLang === 'Tha'"
                      v-model="phone"
                      outlined
                      label="โทรศัพท์"
                      dense
                      hide-details
                      class="py-2"
                    ></v-text-field>
                    <v-text-field
                      v-if="docLang === 'Tha'"
                      v-model="fax"
                      outlined
                      label="โทรสาร"
                      dense
                      hide-details
                      class="py-2"
                    ></v-text-field>
                    <app-headline class="mt-5" title="Noted" />
                    <v-divider class="mt-2"></v-divider>

                    <v-textarea
                      v-model="noted"
                      outlined
                      label="Noted"
                      dense
                      hide-details
                      class="py-2 mt-3"
                    ></v-textarea>

                    <div v-if="isSave" class="text-center success--text mt-5">
                      <h1>
                        <v-icon color="success" size="36" class="pa-2">
                          mdi-check-circle </v-icon
                        >บันทึกสำเร็จ
                      </h1>
                    </div>
                  </v-col>

                  <v-col lg="6" cols="12">
                    <preview-doc
                      v-if="$vuetify.breakpoint.smAndUp"
                      :data="previewData"
                      :lang="docLang"
                    />
                  </v-col>
                </v-row>
                <v-divider> </v-divider>
                <v-row>
                  <v-col class="text-end">
                    <v-btn @click="save()" color="success">
                      บันทึก
                    </v-btn>

                    <export-doc
                      :save="save"
                      :data="previewData"
                      :lang="docLang"
                    />

                    <v-btn
                      class="white--text ml-5"
                      color="grey  "
                      @click="
                        $router.push(
                          '/ReqCer/info/' + $route.params.cercode + '/admin'
                        )
                      "
                      >กลับ</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import PreviewDoc from '@/components/reqcer/admin/previewDoc.vue'
import exportDoc from '@/components/reqcer/admin/exportDoc.vue'

export default {
  components: {
    PreviewDoc,
    exportDoc
  },

  data() {
    return {
      replace: '',
      addrHead: '',
      addr: '๒๓๙ ถนนห้วยแก้ว ตำบลสุเทพ+อำเภอเมือง จังหวัดเชียงใหม่ ๕๐๒๐๐',
      title: 'หนังสือรับรอง',
      number: '',
      paragraph: '',
      exec: {},
      noted: '',
      execList: [],
      isSave: false,
      docLang: 'Tha',
      name: '',
      date: '',
      footer: [],
      phone: '',
      fax: '',
      reqFromReasonId: null,
      additionalParagraph: [],
      addrSelectData: [
        {
          name: '๒๓๙ ถนนห้วยแก้ว ตำบลสุเทพ อำเภอเมือง จังหวัดเชียงใหม่ ๕๐๒๐๐',
          text: '๒๓๙ ถนนห้วยแก้ว ตำบลสุเทพ+อำเภอเมือง จังหวัดเชียงใหม่ ๕๐๒๐๐'
        },

        {
          name:
            '๑๑๐ ถนนอินทวโรรส ซอย ๒ ตำบลสุเทพ อำเภอเมือง จังหวัดเชียงใหม่ ๕๐๒๐๐',
          text:
            '๑๑๐ ถนนอินทวโรรส+ซอย ๒ ตำบลสุเทพ+อำเภอเมือง จังหวัดเชียงใหม่ ๕๐๒๐๐'
        },
        {
          name:
            '๑๑๐/๔๐๖ ถนนอินทวโรรส ซอย ๒ ตำบลสุเทพ อำเภอเมือง จังหวัดเชียงใหม่ ๕๐๒๐๐',
          text:
            '๑๑๐/๔๐๖ ถนนอินทวโรรส+ซอย ๒ ตำบลสุเทพ+อำเภอเมือง จังหวัดเชียงใหม่ ๕๐๒๐๐'
        },
        {
          name: '๒๐๕ หมู่ ๒ ตำบลศรีบัวบาน อำเภอเมือง จังหวัดลำพูน ๕๑๐๐๐',
          text: '๒๐๕ หมู่ ๒ ตำบลศรีบัวบาน+อำเภอเมือง จังหวัดลำพูน ๕๑๐๐๐'
        },
        {
          name: '๑๕๕ หมู่ ๒ ตำบลแม่เหียะ อำเภอเมือง จังหวัดเชียงใหม่ ๕๐๑๐๐',
          text: '๑๕๕ หมู่ ๒ ตำบลแม่เหียะ+อำเภอเมือง จังหวัดเชียงใหม่ ๕๐๑๐๐'
        },
        {
          name:
            '๑๑๙/๗๖ หมู่ ๑ ถนนเอกชัย ตำบลท่าจีน อำเภอเมือง จังหวัดสมุทรสาคร ๗๔๐๐๐',
          text:
            '๑๑๙/๗๖ หมู่ ๑ ถนนเอกชัย+ตำบลท่าจีน อำเภอเมือง+จังหวัดสมุทรสาคร ๗๔๐๐๐'
        }
      ],
      reason: '',
      headerEng: {
        eng: '',
        tha: ''
      },
      footerEng: {}
    }
  },

  computed: {
    previewData() {
      return {
        number: this.number,
        paragraph: this.paragraph,
        exec: this.exec,
        name: this.name,
        date: this.date,
        footer: this.footerData,
        isLoan: this.isLoan,
        additionalParagraph: this.additionalParagraph,
        reqFromReasonId: this.reqFromReasonId,
        reason: this.reason,
        replace: this.replace,
        addr: this.addrData,
        addrHead: this.addrHead,
        headerEng: this.headerEng,
        footerEng: this.footerEng
      }
    },
    footerData() {
      let temp = [...this.footer]
      temp[this.footer.length - 1] = 'โทรสาร ' + this.fax
      temp[this.footer.length - 2] = 'โทรศัพท์ ' + this.phone
      return temp
    },
    footerBody() {
      let temp = [...this.footer]
      temp[this.footer.length - 1] = this.fax
      temp[this.footer.length - 2] = this.phone
      return temp
    },
    isLoan() {
      return this.reqFromReasonId === 4 || this.reqFromReasonId === 5
    },
    addrData() {
      return this.addr.split('+')
    }
  },

  mounted() {
    this.initialinfo()
  },

  methods: {
    async save() {
      let paragraph_t = this.paragraph
      if (this.isLoan) {
        this.additionalParagraph.forEach(item => {
          paragraph_t = paragraph_t + '<br>' + item
        })
      }

      let footer_t = ''
      if (this.docLang === 'Tha') {
        this.footerBody.forEach(item => {
          footer_t = footer_t + item + '<br>'
        })
        // footer_t = 'สำนักบริการเทคโนโลยีสารสนเทศ<br>000<br>000<br>'
      }
      // console.log(footer_t)
      let body = {
        ReqCardId: this.$route.params.cercode,
        ReqCertNumber: this.number,
        ReqCertNote: this.noted,
        ReqCertSignName: this.exec.employeeNamePositionTha || '',
        Paragraph1: paragraph_t,
        footer1: footer_t,
        SingPosition: this.replace
      }
      await this.apiPutPreviewData(body)
      // console.log(paragraph_t)
    },

    async initialinfo() {
      const res = await this.apiGetPreviewData()
      this.execList = res.signNameList || []
      this.number = res.reqCertNumber || ''
      this.reqFromReasonId = res.reqFromReason.trReqFormReasonTypeId
      this.reason = res.reqFromReason.reqFormReasonTypeNameTha

      if (this.isLoan) {
        this.paragraph = res.paragraph1.split('<br>')[0]
        this.additionalParagraph = res.paragraph1.split('<br>')
        this.additionalParagraph.splice(0, 1)
      } else {
        this.paragraph = res.paragraph1 || ''
      }

      this.exec =
        res.signNameList.filter(item => {
          return item.employeeNamePositionTha === res.reqCertSignName
        })[0] || {}

      this.noted = res.reqCertNote || ''
      this.docLang = res.language
      this.name = res.name
      this.date = res.date
      this.footer = res.footer1.split('<br>')
      if (!this.footer[this.footer.length - 1]) {
        this.footer.pop()
      }
      this.addrHead = res.addressHeader.split('<br>')
      this.fax = this.footer[this.footer.length - 1]
      this.phone = this.footer[this.footer.length - 2]
      this.replace = res.singPosition || ''
      this.footerEng = res.organModelView
      this.headerEng = {
        eng: res.organLv1Eng,
        tha: res.organLv1Tha
      }
      // console.log(this.footer)
    },

    async apiGetPreviewData() {
      try {
        const res = await this.$store.dispatch(
          'reqCer/getPreviewData',
          this.$route.params.cercode
        )
        return res.data.data
      } catch (e) {
        console.log(e.response || e)
      }
    },

    async apiPutPreviewData(body) {
      try {
        this.isSave = false
        const res = await this.$store.dispatch('reqCer/putPreviewData', body)
        this.isSave = true
        return res
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>
